import type { ReactNode } from 'react';
import { AnimatePresence, m } from 'motion/react';

type StepTransitionProps = {
  /** Keys the transition — a new step cross-fades in as the old one fades out. */
  stepKey: string;
  className?: string;
  children: ReactNode;
};

/** Cross-fades the funnel's step content when the step changes. */
export function StepTransition({ stepKey, className, children }: StepTransitionProps) {
  return (
    <AnimatePresence mode="wait" initial={false}>
      <m.div
        key={stepKey}
        className={className}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.15 }}
      >
        {children}
      </m.div>
    </AnimatePresence>
  );
}
